var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"video-sdk-container",staticClass:"tw-min-h-[75vh]",attrs:{"id":"video-sdk-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }